export default "/images/5af31394249f1c65440994a8bf9bc630.avif";